import { Action } from '@ngrx/store';


export enum DSceneTypes {
  SCENE_DSCENE = '[SCENE] DeleteScene',
  SCENE_DSCENE_SUCCESS = '[SCENE] DSceneSuccess',
  SCENE_DSCENE_FAILURE = '[SCENE] DSceneFailure',
  SCENE_DSCENE_RESET = '[SCENE] DSceneReset ',
}

export class DSceneReset implements Action {
  readonly type = DSceneTypes.SCENE_DSCENE_RESET;
  constructor() {}
}
export class DScene implements Action {
  readonly type = DSceneTypes.SCENE_DSCENE;
  constructor(public claveS: number, public claveU: number) {}
}

export class DSceneSuccess implements Action {
  readonly type = DSceneTypes.SCENE_DSCENE_SUCCESS;
  constructor(public result: any) {}
}

export class DSceneFailure implements Action {
  readonly type = DSceneTypes.SCENE_DSCENE_FAILURE;
  constructor(public payload: any) {}
}


export type DSceneAcciones =
  | DScene
  | DSceneSuccess
  | DSceneFailure
  | DSceneReset;